var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "root" }, [
    _c("div", { staticClass: "manuscript-editor" }, [
      _c("div", { staticClass: "bottom sp" }, [
        _c(
          "button",
          { staticClass: "back sp", on: { click: _vm.handleBackAction } },
          [_vm._v("＜")]
        ),
        _c(
          "div",
          {
            ref: "spSave",
            staticClass: "sp save",
            attrs: { "data-disabled": !_vm.changed },
            on: { click: _vm.save },
          },
          [
            _c("img", {
              attrs: { src: require("@/assets/img/icon/icon-save.png") },
            }),
            _vm._v(
              _vm._s(_vm.$t("manuscriptPage.manuscriptEditor.save")) + " "
            ),
          ]
        ),
        _c("div", { staticClass: "edit-manu" }, [
          _c("img", {
            attrs: { src: require("@/assets/img/icon/icon-edit-menu.png") },
            on: { click: _vm.showMenu },
          }),
        ]),
        _vm.content !== null
          ? _c("div", { staticClass: "text-counter" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("manuscriptPage.manuscriptEditor.characterCount", {
                      count: _vm.displayedContentLength,
                    })
                  ) +
                  " "
              ),
            ])
          : _vm._e(),
      ]),
      _c(
        "div",
        {
          staticClass: "main-content",
          class: {
            "with-assist":
              _vm.isAssistPanelVisible && !_vm.isShowPreview && !_vm.isMobile,
          },
        },
        [
          _c(
            "div",
            { staticClass: "manuscript-container" },
            [
              _c("manuscript-header", {
                ref: "header",
                attrs: {
                  title: _vm.title,
                  novelId: _vm.novelId,
                  manuscriptKey: _vm.manuscriptKey,
                  getContent: _vm.getLiveContent,
                  changed: _vm.changed,
                },
                on: {
                  changeTitle: _vm.onChangeTitle,
                  compositionStart: _vm.onStartComposition,
                  compositionEnd: _vm.onEndComposition,
                  post: function ($event) {
                    return _vm.onExportButtonClick(true)
                  },
                  save: _vm.save,
                  commentIconClicked: _vm.handleCommentIconClick,
                },
              }),
              _c(
                "div",
                {
                  staticClass: "editor-container",
                  class: { isShowPreview: _vm.isShowPreview },
                },
                [
                  _c("editor", {
                    ref: "editor",
                    attrs: {
                      content: _vm.content,
                      isScriptMode: _vm.isScriptMode,
                    },
                    on: {
                      changeContent: _vm.onChangeContent,
                      typing: _vm.onTyping,
                      compositionStart: _vm.onStartComposition,
                      compositionEnd: _vm.onEndComposition,
                    },
                  }),
                  _c("save-status-indicator", {
                    staticClass: "save-status-indicator",
                    attrs: { status: _vm.saveStatus },
                  }),
                  _vm.isShowPreview
                    ? _c("manuscript-preview", {
                        staticClass: "preview pc",
                        attrs: {
                          novelId: _vm.novelId,
                          manuscriptList: _vm.manuscriptList,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "bottom pc",
                  class: {
                    scriptVertical:
                      _vm.isScriptMode && _vm.isVerticalWritingMode,
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "controller-container gap-1 ml-1" },
                    [
                      _c("undo-icon", {
                        attrs: {
                          fillColor: _vm.canUndo
                            ? _vm.activeColor
                            : _vm.defaultColor,
                        },
                        on: { click: _vm.undo },
                      }),
                      _c("redo-icon", {
                        attrs: {
                          fillColor: _vm.canRedo
                            ? _vm.activeColor
                            : _vm.defaultColor,
                        },
                        on: { click: _vm.redo },
                      }),
                      _c("hr", { staticClass: "vertical-hr" }),
                      _c("div", { staticClass: "editor-controller" }, [
                        _c("div", { staticClass: "insert-symbol" }, [
                          _c(
                            "div",
                            {
                              staticClass: "icon-box",
                              on: { click: _vm.brackets },
                            },
                            [_c("icon-punctuation-mark")],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "icon-box",
                              on: { click: _vm.ellipsis },
                            },
                            [_c("icon-leader")],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "icon-box",
                              on: { click: _vm.space },
                            },
                            [_c("icon-space")],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "icon-box",
                              on: { click: _vm.dash },
                            },
                            [_c(_vm.dashIcon, { tag: "component" })],
                            1
                          ),
                          !_vm.isScriptMode
                            ? _c(
                                "div",
                                {
                                  staticClass: "icon-box",
                                  on: { click: _vm.ruby },
                                },
                                [_c("icon-ruby")],
                                1
                              )
                            : _vm._e(),
                          !_vm.isScriptMode
                            ? _c(
                                "div",
                                {
                                  staticClass: "icon-box",
                                  on: { click: _vm.emphasisMark },
                                },
                                [_c("icon-side-point")],
                                1
                              )
                            : _vm._e(),
                          _vm.isScriptMode
                            ? _c(
                                "div",
                                {
                                  staticClass: "icon-box",
                                  on: { click: _vm.insertPillar },
                                },
                                [_c("icon-circle")],
                                1
                              )
                            : _vm._e(),
                          _vm.isScriptMode
                            ? _c(
                                "div",
                                {
                                  staticClass: "icon-box",
                                  on: { click: _vm.insertTogaki },
                                },
                                [_c("icon-togaki")],
                                1
                              )
                            : _vm._e(),
                          _vm.isScriptMode
                            ? _c(
                                "div",
                                {
                                  staticClass: "icon-box",
                                  on: { click: _vm.insertFlashback },
                                },
                                [_c("icon-flashback")],
                                1
                              )
                            : _vm._e(),
                        ]),
                      ]),
                      _c("hr", { staticClass: "vertical-hr" }),
                      !_vm.isAssistPanelVisible
                        ? _c(
                            "div",
                            { staticClass: "multi-editor-link-wrapper md" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "button default multi-editor-link",
                                  on: { click: _vm.goToMultiEditor },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "manuscriptPage.manuscriptEditor.multiEditorMode"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _vm.isFree
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "multi-editor-premium-badge",
                                      attrs: {
                                        "data-tooltip": _vm.$t(
                                          "exportManuscriptDialog.premiumOnly"
                                        ),
                                      },
                                      on: { click: _vm.goToMultiEditor },
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/img/icon/premium.png"),
                                          alt: "Premium",
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                      !_vm.isVerticalWritingMode
                        ? _c("div", { staticClass: "show-preview-wrapper" }, [
                            _c(
                              "div",
                              {
                                staticClass: "show-preview",
                                class: { isShowPreview: _vm.isShowPreview },
                                on: { click: _vm.onClickPreview },
                              },
                              [_c("icon-preview-vertical")],
                              1
                            ),
                            _vm.isFree
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "premium-badge",
                                    attrs: {
                                      "data-tooltip": _vm.$t(
                                        "exportManuscriptDialog.premiumOnly"
                                      ),
                                    },
                                    on: { click: _vm.onClickPreview },
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/img/icon/premium.png"),
                                        alt: "Premium",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "setting-container" },
                    [
                      _c("dropup-menu", {
                        staticClass: "dropup-menu",
                        attrs: {
                          title: _vm.countTypeName,
                          content: _vm.wordCountInfo,
                          items: _vm.countTypeList,
                          styleObject: {
                            backgroundColor: "var(--color-surface-muted)",
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c("proofreading-confirmation-dialog"),
                  _c("auto-indent-confirmation-dialog"),
                ],
                1
              ),
            ],
            1
          ),
          _c("assist-panel", { staticClass: "assist-panel pc" }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }